<template><!-- svgo-optimised -->
<svg class="icon icon__Play icon icon__play" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="40" fill="none" r="39.5" /><path d="M47 39.134a1 1 0 0 1 0 1.732l-12 6.928a1 1 0 0 1-1.5-.866V33.072a1 1 0 0 1 1.5-.866z" /></svg>
</template>